import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import LanguageToggle from "./LanguageToggle";
import SearchPalette from "./SearchPalette";
import ThemeToggle from "./ThemeToggle";
import HowWeWorkMenu from "./HowWeWorkMenu";
import BehindTheLightMenu from "./BehindTheLightMenu";
import MobileMenu from "./MobileMenu";
import { Wordmark } from "../ui/BrandMark";
import useLang from "../../hooks/useLang";

// Minimal bar: logo, How We Work and Behind the Light panels, search, theme and language icons,
// and the main call to action. Below md the panels and toggles live in the MobileMenu sheet.
const Navbar = () => {
  const { t, dir } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-ink/90 backdrop-blur-md transition-[border-color] duration-500 border-b ${
        scrolled ? "border-white/10" : "border-transparent"
      }`}
      dir={dir}
    >
      <div className="container-site">
        <div className="flex items-center justify-between gap-2 sm:gap-4 h-[72px]">
          <Link to="/" className="flex items-center flex-shrink-0" aria-label="Applumo">
            <Wordmark variant="onDark" />
          </Link>

          <div className="relative flex items-center gap-1 sm:gap-3">
            <div className="hidden md:flex items-center">
              <HowWeWorkMenu />
              <BehindTheLightMenu />
            </div>
            <SearchPalette />
            {/* On phones these two move into the menu sheet. */}
            <div className="hidden md:flex items-center gap-3">
              <ThemeToggle />
              <LanguageToggle icon />
            </div>
            <MobileMenu />
            <Link to="/contact" className="btn-rose !px-3 sm:!px-4 !py-2.5 group whitespace-nowrap">
              {t("cta.button")}
              <ArrowRight
                size={15}
                className={`hidden sm:block transition-transform duration-300 group-hover:translate-x-0.5 rtl:rotate-180`}
              />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
